import React from 'react'
import {Link} from 'react-router-dom'
import Header from '../../components/Primary/Header'
import store from '../../assets/store.png'
import ProductCard from '../../components/Primary/ProductCard'
import {IoIosArrowForward} from 'react-icons/io'

import { CartState } from "../../context/Context";
import Footer from '../../components/Primary/Footer'
const LandingPage = () => {
  const {
    state: { products, cart },
   
  } = CartState();
  const findQty = id => {
    const item = cart.find(item => item.id === id);
    if(item){
      return item.qty
    }
    return null
  }
  return (

    <div className="bg-tradr-light h-full w-full 2xl:container 2xl:mx-auto ">
        <Header />
        <div className="md:px-8 md:py-4  ">
        {/* WELOCOME CARD */}

        <div className="flex bg-blue mt-0 md:mt-14 space-x-4 rounded-lg px-4 py-8  ">
          {/* Left welcome */}
            <div className="flex flex-col items-start w-full lg:w-4/12 ">
                <h1 className=" font-bold block text-large text-white break-words w-full" 
                >
                
                Welcome to 
                <br/>
      Crowncollections Store
      </h1>
      <p className="text-sm font-light mb-4 text-gray-light">
      Satisfying your cravings
      </p>
      <Link to="/all-products" className="btn bg-tradr-green text-white font-normal py-2 px-4  uppercase mb-4">
      View All Products
      </Link>

          </div>
          {/* Right welcome */}
          <div className=" hidden md:flex  justify-end items-center w-full lg:w-8/12  ">
         <div className="relative w-72">
           <img src={store} alt="store" className="w-6/6 h-80 rounded-lg cursor-pointer  absolute -top-40 right-10  object-cover  " 
          />
           
         </div>
          </div>
          </div>
        {/* END OF  WELOCOME CARD */}
        {/* Product action */}
        <div className="flex  items-center justify-between mt-2 md:mt-20 px-2">
          <div
          >
             <h1 className="font-poppins font-bold text-large" >
     Our Products
     </h1>
     <div className="underline" />
          </div>
          <div
          >
            <Link to="/all-products" className="font-poppins flex justify-between space-x-2 align-center font-medium  text-base mb-2 bg-light-blue px-4 py-2 mt-2 hover:bg-tradr-green hover:text-white" >
            <p>View All </p> <IoIosArrowForward className="mt-1" fontSize={20} /> 
            </Link>
          </div>
          </div>
          {/* End of product action */}
          {/* Product cards */}
          <div className="flex md:flex-wrap  flex-col md:flex-row justify-center lg:justify-start mt-4 md:mt-8">
        {
          products.map((prod) => {
          
            return (
              <ProductCard  key={prod.id} prod={prod} qty={findQty(prod.id)} />
            )
          })
        }
          
        
          </div>
          {/* End of Product Card */}
          {/* View All Product */}
          <div className="flex justify-center mt-4">
          <Link to="/all-products" className="font-poppins font-medium  text-base mb-2 text-white bg-tradr-green px-8 lg:px-24 py-2  " >
            View All Products
            </Link>
            </div>

        </div>
        <Footer />
        </div>
  )
}

export default LandingPage